import React from 'react';
import Icon from '../../../components/AppIcon';

const MonitoringCard = ({ title, value, subtitle, icon, trend, trendValue, threshold, status }) => {
  const getStatusColor = () => {
    if (!status) return 'text-foreground';
    switch (status) {
      case 'critical':
        return 'text-error';
      case 'warning':
        return 'text-warning';
      case 'success':
        return 'text-success';
      default:
        return 'text-foreground';
    }
  };

  const getStatusBg = () => {
    if (!status) return 'bg-muted';
    switch (status) {
      case 'critical':
        return 'bg-error/10';
      case 'warning':
        return 'bg-warning/10';
      case 'success':
        return 'bg-success/10';
      default:
        return 'bg-muted';
    }
  };

  const getTrendIcon = () => {
    if (!trend) return null;
    return trend === 'up' ? 'TrendingUp' : 'TrendingDown';
  };

  const getTrendColor = () => {
    if (!trend) return 'text-muted-foreground';
    if (status === 'critical' || status === 'warning') {
      return trend === 'up' ? 'text-error' : 'text-success';
    }
    return trend === 'up' ? 'text-success' : 'text-error';
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 shadow-sm hover:shadow-md transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1 min-w-0">
          <p className="text-xs md:text-sm text-muted-foreground mb-1">{title}</p>
          <h3 className={`text-2xl md:text-3xl lg:text-4xl font-semibold ${getStatusColor()}`}>
            {value}
          </h3>
        </div>
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg ${getStatusBg()} flex items-center justify-center flex-shrink-0`}>
          <Icon name={icon} size={24} className={getStatusColor()} />
        </div>
      </div>

      <div className="flex items-center justify-between">
        <p className="text-xs md:text-sm text-muted-foreground">{subtitle}</p>
        {trend && trendValue && (
          <div className={`flex items-center gap-1 ${getTrendColor()}`}>
            <Icon name={getTrendIcon()} size={16} />
            <span className="text-xs md:text-sm font-medium">{trendValue}</span>
          </div>
        )}
      </div>

      {threshold && (
        <div className="mt-3 pt-3 border-t border-border">
          <div className="flex items-center justify-between text-xs">
            <span className="text-muted-foreground">Ambang Batas</span>
            <span className={`font-medium ${getStatusColor()}`}>{threshold}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default MonitoringCard;